// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__1goj0","label":"PriceFilterPopup_label__2nyUJ","labelSelected":"PriceFilterPopup_labelSelected__2nnxO"};